import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'clsx';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import style from './style.module.less';

import type { IconDefinition } from '@fortawesome/fontawesome-common-types';

const ColorToStyleMap = {
  [THEME_CONSTANTS.primary]: style.primary,
  [THEME_CONSTANTS.unstyled]: style.unstyled,
  [THEME_CONSTANTS.white]: style.white,
};

const IconSizeToStyleMap = {
  small: style['small-icon'],
  medium: style['medium-icon'],
  large: style['large-icon'],
};

type InfoIconColor = typeof THEME_CONSTANTS.primary | typeof THEME_CONSTANTS.unstyled | typeof THEME_CONSTANTS.white;
type InfoIconSize = 'small' | 'medium' | 'large';

type InfoIconProps = {
  className?: string;
  color?: InfoIconColor;
  position?: string;
  size?: InfoIconSize;
  tooltipText: React.ReactNode;
  icon?: IconDefinition;
};

export const InfoIcon: React.FC<InfoIconProps> = ({
  className = '',
  color = THEME_CONSTANTS.primary,
  position = 'top',
  size = 'medium',
  tooltipText,
  icon = faInfoCircle,
}) => {
  const spanClasses = classnames(ColorToStyleMap[color], className);
  const svgClasses = IconSizeToStyleMap[size] || IconSizeToStyleMap.medium;

  return (
    <Tooltip position={position}>
      <TooltipContent>{tooltipText}</TooltipContent>
      <span className={spanClasses}>
        <FontAwesomeIcon className={svgClasses} icon={icon} />
      </span>
    </Tooltip>
  );
};
